// Core Modules
import { AsyncPipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

// External Modules
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

// Components
import { UserSettingsComponent } from '@shared/components/header/user-settings/user-settings.component';

// Services
import { AuthService } from '@core/services/auth/auth.service';
import { ConfigService } from '@core/services/config/config.service';

// Models
import { HeaderContentModel } from '@shared/models/header-content.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: true,
  imports: [AsyncPipe, NgbTooltipModule, RouterLink, UserSettingsComponent],
})
export class HeaderComponent {
  // Bindings
  @Input() hideSettings?: Observable<boolean>;

  // Injectors
  public readonly authService = inject(AuthService);
  private readonly configService = inject(ConfigService);

  // Public Members
  public readonly headerContents: HeaderContentModel = this.configService.getContents('header');
  public isMenuCollapsed = false;
}
